import { gql } from "graphql-tag";

/**
 * Fetches Group info using group id
 *
 * variable example
 * {"groupId": "16383"}
 */
export const GET_GroupInfo = gql`
  query GET_GroupInfo($groupId: String!) {
    groupInfo: GroupRead(id: $groupId) {
      name: Name
      id: Id
      itemTokenSettingList: ItemTokenSettingList {
        id: Id
        groupId: GroupId
        tokenLength: TokenLength
        createdAt: CreatedAt
        updatedAt: UpdatedAt
      }
      adyenTerminals: AdyenTerminals
      entityType: LegalEntityType
      registrationNumber: RegistrationNumber
      dateFormatB2b: DateFormatB2b
      timeFormatB2b: TimeFormatB2b
      currency: Currency
      brandingList: BrandingList {
        brandingPictureList: BrandingPictureList {
          Id
          name: Name
          type: Type
          dimensions: Dimensions
          url: Url
        }
        email: EmailAddress
        phoneNumber: PhoneNumber
        city: City
        address: Address
        zip: Zip
        country: CountryRead {
          name: Name
          alpha2: Alpha2
        }
        vatNumber: VatNumber
        exoNumber: ExoNumber
      }
      adyenAccountHolderList: AdyenAccountHolderList {
        adyenAccountList: AdyenAccountList {
          accountCode: AccountCode
        }
      }
      # adyen migration
      adyenAccountHolderNewList: AdyenAccountHolderNewList {
        adyenBalanceAccount: AdyenBalanceAccountList {
          balanceAccountId: BalanceAccountId
        }
      }
      adyenMerchantAccount: AdyenMerchantAccount
      seatsPublicKey: SeatsPublicKey
      seatsPrivateKey: SeatsPrivateKey
      oneTokenVoucherTickets: OneTokenVoucherTickets
      weekStartB2b: WeekStartB2b
      skidataHandshakeList: SkidataHandshakeList {
        qrCodeType: QrCodeType
        integrationType: IntegrationType
      }
      groupUuid: Uuid
    }
  }
`;

export const GET_GroupCurrencyExchange = gql`
  query GET_GroupCurrencyExchange($groupId: String!) {
    GroupCurrencyExchangeList(condition: { GroupId: { eq: $groupId } }) {
      id: Id
      label: Currency
      groupId: GroupId
      status: Status
      isDefault: IsDefault
      exchangeRate: Rate
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

export const GET_GroupEploToken = gql`
  query GET_GroupEploToken($groupId: String!) {
    GroupExploList(condition: { GroupId: { eq: $groupId } }) {
      id: Id
      groupId: GroupId
      token: Token
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
